import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'kiene-lieferanten-layout',
    templateUrl: './lieferanten-layout.component.html',
    styleUrls: ['./lieferanten-layout.component.scss'],
})
export class LieferantenLayoutComponent {
    constructor(private router: Router) {}

    isLieferantenStammActive(): boolean {
        const url = this.router.url.split('?')[0];
        if (url.includes('/lieferanten/institutionen') || url.includes('/lieferanten/sonstige-kunden')) {
            return false;
        }
        return url.startsWith('/lager/lieferanten');
    }
}
